// extracted by mini-css-extract-plugin
export default {"separator":"TermsForm_separator__6ukJC"};